// extracted by mini-css-extract-plugin
module.exports = {"notice":"VehicleFields_notice__1lXoE","container":"VehicleFields_container__3D0F3","error":"VehicleFields_error__1Vqwd"};